import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { addExtraReducer } from '../../../../store/addExtraReducer'
import { LoadingStatusEnum } from '../../../../store/types'

import initialState from './initialState'
import { GetBlockedIpsReducer, UpdateBlockedIpReducer } from './reducers'
import { SLICE_NAME, GetBlockedIps, UpdateBlockedIp } from './thunks'

const BlockedIpsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    updateSearch: (state, action: PayloadAction<string>) => {
      state.loading = LoadingStatusEnum.Pending
      state.search = action.payload
    },
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetBlockedIps, GetBlockedIpsReducer)
    addExtraReducer(builder, UpdateBlockedIp, UpdateBlockedIpReducer)
  },
})

export const { updateSearch } = BlockedIpsSlice.actions

export default BlockedIpsSlice.reducer
